module.exports = __webpack_public_path__ + "static/media/category-ignored.d98ea449.svg";